/* eslint-disable no-extend-native */

import sStartsWith from 'underscore.string/startsWith';

String.prototype.startsWith = function (...args) {
  return sStartsWith(this, ...args);
};

export const ellipsis = (str, limit) => {
  if (str.length > limit) {
    return `${str.substring(0, limit - 3)}...`;
  } else {
    return str;
  }
};
